// extracted by mini-css-extract-plugin
module.exports = {"select-client-dialog":"select-client-dialog-eed0ea36d861591faffa1cbb01238311"};